import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { PoolerType } from 'server/shared/models/poolerType';
import { CustomerService } from '../../services/customer.service';

@Component({
  selector: 'app-pooler-type-multi-select',
  templateUrl: './pooler-type-multi-select.component.html',
  styleUrls: ['./pooler-type-multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoolerTypeMultiSelectComponent {
  customerPoolerTypes$ = this.customerService.readyDispoCustomer$.pipe(
    map((customer) => customer?.poolerTypes || []),
  );

  disabled$ = new BehaviorSubject<boolean>(false);
  @Input() set disabled(value: boolean) {
    this.disabled$.next(value);
  }
  get disabled() {
    return this.disabled$.value;
  }

  selectedPoolerTypeIds$ = new BehaviorSubject<string[]>([]);
  @Input() set selectedPoolerTypeIds(value: string[]) {
    this.selectedPoolerTypeIds$.next(value);
  }
  get selectedPoolerTypeIds() {
    return this.selectedPoolerTypeIds$.value;
  }

  @Input() set selectedPoolerTypes(poolerTypes: PoolerType[]) {
    this.selectedPoolerTypeIds$.next(
      poolerTypes.map((poolerType) => poolerType.id),
    );
  }
  @Output() selectionChanged = new EventEmitter<string[]>();

  hintContent$ = new BehaviorSubject<TemplateRef<any> | undefined>(undefined);
  @ContentChild('hint') set hintContent(value: TemplateRef<any> | undefined) {
    this.hintContent$.next(value);
  }
  get hintContent() {
    return this.hintContent$.value;
  }

  constructor(private customerService: CustomerService) {}

  onSelectionChange(selectedIds: string[]) {
    this.selectedPoolerTypeIds$.next(selectedIds);
    this.selectionChanged.emit(selectedIds);
  }
}
